import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { SketchPicker } from 'react-color'
import IconButton from 'material-ui/IconButton';
import ActionColor from 'material-ui/svg-icons/image/lens';
import styled from 'styled-components';

class ColorPicker extends Component{
  constructor(props){
    super(props);
    this.state = {
      displayColorPicker: false,
      color:props.color,
      result: props.color
    }
  }
  handleClick = () => {
    this.setState({ displayColorPicker: !this.state.displayColorPicker })
  }

  handleClose = () => {
    this.setState({ displayColorPicker: false })
  }

  handleChange = (color) => {
    let {hex} = color;
    this.setState({ color: hex, result : hex});
  }
  handleChangeComplete = (color, event) => {
    let {hex} = color;
    this.props.onUpdateColor(hex);
  }
  componentWillReceiveProps(nextProps){
    if(this.props.color !== nextProps.color){
      this.setState({ color: nextProps.color, result : nextProps.color});
    }
  }

  render(){
    const {title} = this.props;
    return(
      <DivContainer>
        <Title>{title}</Title>
        <IconButton onClick={this.handleClick} style={styles.iconButton} iconStyle={{ width:36, height:36, border: '2px solid #DAD1D1', borderRadius: '18px'}} >
          <ActionColor color={this.state.result} />
        </IconButton>
        { this.state.displayColorPicker ? <div style={ styles.popover }>
          <div style={ styles.cover } onClick={ this.handleClose }/>
          <SketchPicker color={ this.state.color } onChange={ this.handleChange } onChangeComplete={ this.handleChangeComplete }  />
        </div> : null }
      </DivContainer>
    )
  }
}

const styles = {
    swatch: {
      padding: '5px',
      background: '#fff',
      borderRadius: '1px',
      boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
      display: 'inline-block',
      cursor: 'pointer',
    },
    popover: {
      position: 'absolute',
      zIndex: '2',
      paddingTop:60
    },
    cover: {
      position: 'fixed',
      top: '0px',
      right: '0px',
      bottom: '0px',
      left: '0px',
    },
    iconButton:{
      width:72,
      height:72
    }
}
const DivContainer = styled.div`
  display: flex;
`
const Title = styled.span`
  align-items: center;
  display: flex;
`;


ColorPicker.propTypes = {
  title:PropTypes.string,
  color: PropTypes.string,
  onUpdateColor : PropTypes.func.isRequired
};
//
ColorPicker.defaultProps = {
  color:'#4A90E2',
  title: 'Background Color '
};


export default ColorPicker;



// WEBPACK FOOTER //
// ./src/components/mui/ColorPicker.js